import React from "react";
import { Box, Typography, IconButton } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import SubTopicGraphCard from "./SubTopicGraphCard";

const PillarAccordion = ({ pillar, section, analytics, open = false, onToggle }) => {
  return (
    <Box
      id={`pillar-${pillar.id}`} // ✅ scroll target
      sx={{
        mb: 2,
        background: "rgba(255,255,255,0.85)",
        backdropFilter: "blur(8px)",
        borderRadius: 3,
        boxShadow: "0 2px 10px rgba(0,0,0,0.12)",
        overflow: "hidden",
      }}
    >
      {/* Header */}
      <Box
        sx={{
          px: 3,
          py: 2,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          cursor: "pointer",
          transition: "background 0.2s ease",
          "&:hover": { background: "rgba(0,0,0,0.04)" },
        }}
        onClick={onToggle}
      >
        <Typography variant="h6" fontWeight={600} sx={{ lineHeight: 1.3 }}>
          {pillar.name}
        </Typography>

        <IconButton
          size="small"
          disableRipple
          sx={{
            transform: open ? "rotate(180deg)" : "rotate(0deg)",
            transition: "transform 0.2s ease",
          }}
        >
          <ExpandMoreIcon />
        </IconButton>
      </Box>

      {/* Content */}
      {open && (
        <Box
          sx={{
            px: 3,
            pb: 3,
            pt: 1,
            borderTop: "1px solid rgba(0,0,0,0.06)",
            display: "flex",
            flexDirection: "column",
            gap: "0px",
          }}
        >
          {pillar.topics.map((topic) => (
            <SubTopicGraphCard
              key={topic.id}
              topic={topic}
              section={section}
              analyticsSkills={analytics}
            />
          ))}
        </Box>
      )}
    </Box>
  );
};

export default PillarAccordion;
